<template>
    <v-container fluid>
     <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
        <v-col cols="12" md="6">
            <v-card>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/logo-large.png" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Email Us</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">Have a question or want to provide feedback?<br/>Email us at support@pappyon.com</p>
                    <v-row justify="center" align="center">
                      <v-btn href="mailto:support@pappyon.com" class="primary" width="250" large elevation="0">Email</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="6">
            <v-card>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row class="mb-5" justify="center" align="center">
                      <img src="../assets/logo-large.png" height="60" width="60"/>
                    </v-row>
                    <p class="text-h5 text-center secondary--text">Call Us</p>
                    <p class="text-subtitle-1 text-center mt-n3 secondary--text">Call the Pappyon Team  on<br/>1800 123 123 (Australia Only)</p>
                    <v-row justify="center" align="center">
                      <v-btn href="tel:+61-1800-123-123" class="primary" width="250" large elevation="0">Call</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
     </v-row>
     <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
        <v-col cols="12">
            <v-card>
              <v-card-text>
                <v-row justify="center">
                    <v-col >
                        <v-card
                            class="mx-auto"
                            tile
                            flat
                        >
                        <v-toolbar flat dense color="transparent">
                            <v-toolbar-title class="secondary--text">Or maybe we might have already answered your question?</v-toolbar-title>
                        </v-toolbar>
                        <v-list nav dense>
                            <v-list-item-group v-model="links" color="primary">
                            <v-list-item
                                v-for="(link, i) in links"
                                :key="i"
                                router
                                :to="link.to"
                            >
                                <v-list-item-avatar>
                                <!-- <v-icon v-text="link.icon" class="primary white--text"></v-icon> -->
                                <v-icon class="primary--text">add_circle_outline</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                <v-list-item-title v-text="link.title" class="secondary--text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        </v-card>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
     </v-row>
  </v-container>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Support',
  data() {
    return {
      links: [
          { title: 'Read our User Guides here', to: '/'},
          { title: 'Discover how to customize your card designs here', to: '/'},
          { title: 'Here are our tips on how to manage your Team', to: '/'},
          { title: 'For Plans and Pricing information go here', to: '/'},
          { title: 'For Account Management read our User Guide here.', to: '/'},
          { title: 'Or maybe our FAQs might help?', to: '/'}
        ],
    }
  }
}
</script>